import { render, staticRenderFns } from "./putOrderMap.vue?vue&type=template&id=24c8aafa&scoped=true&"
import script from "./putOrderMap.vue?vue&type=script&lang=js&"
export * from "./putOrderMap.vue?vue&type=script&lang=js&"
import style0 from "./putOrderMap.vue?vue&type=style&index=0&id=24c8aafa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8aafa",
  null
  
)

export default component.exports